var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.039 21.623 h -4.877 c -3.069 0 -5.888 -1.704 -7.335 -4.432 l -1.472 -2.777 c -1.814 -3.421 -5.349 -5.557 -9.197 -5.557 H 31.842 c -3.848 0 -7.383 2.136 -9.197 5.557 l -0.464 0.876 l -1.008 1.901 c -0.983 1.854 -2.6 3.235 -4.499 3.93 c -0.895 0.328 -1.853 0.502 -2.836 0.502 H 8.961 C 4.012 21.623 0 25.668 0 30.657 v 41.452 c 0 4.989 4.012 9.034 8.961 9.034 h 72.079 c 1.835 0 3.541 -0.556 4.962 -1.51 C 88.412 78.014 90 75.249 90 72.109 V 30.657 C 90 25.668 85.988 21.623 81.039 21.623 z M 63.806 57.253 c -1.028 2.588 -2.565 4.914 -4.488 6.852 C 55.654 67.8 50.592 70.085 45 70.085 c -11.183 0 -20.249 -9.14 -20.249 -20.415 c 0 -5.637 2.266 -10.741 5.931 -14.435 c 1.923 -1.938 4.23 -3.489 6.797 -4.525 c 2.325 -0.938 4.863 -1.455 7.521 -1.455 c 11.183 0 20.249 9.14 20.249 20.415 C 65.249 52.35 64.737 54.909 63.806 57.253 z M 77.341 36.522 c -1.914 0 -3.465 -1.564 -3.465 -3.494 c 0 -1.929 1.551 -3.493 3.465 -3.493 c 1.914 0 3.465 1.564 3.465 3.493 C 80.806 34.958 79.255 36.522 77.341 36.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.951 53.682 c -0.544 1.369 -1.357 2.6 -2.375 3.626 c -1.939 1.955 -4.617 3.164 -7.576 3.164 c -5.917 0 -10.714 -4.836 -10.714 -10.802 c 0 -2.983 1.199 -5.683 3.138 -7.638 c 1.017 -1.026 2.238 -1.846 3.597 -2.394 c 1.23 -0.497 2.573 -0.77 3.98 -0.77 c 5.917 0 10.714 4.836 10.714 10.802 C 55.714 51.088 55.443 52.442 54.951 53.682 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.e9c905b8556a58f1fac009f44a2a1598.svg";
export { ForwardRef as ReactComponent };